// Enlaces a la guía de uso de la tienda (/uso, pantallas/Uso.tsx): en Entrar ("¿Primera vez? Mirá cómo se usa") y en
// Tu cuenta. La guía se ve con o sin cuenta.
import { cx, Icono } from '@reparto/ui';
import { Link } from 'react-router';

export function EnlaceUso({ className }: { className?: string }) {
  return (
    <Link
      to="/uso"
      className={cx(
        'inline-flex min-h-11 items-center gap-1.5 rounded-full px-3 text-base font-semibold text-primary-700 underline-offset-4 hover:underline',
        'focus-visible:outline-2 focus-visible:outline-primary-600',
        className,
      )}
    >
      <Icono nombre="help" tamano={22} />
      ¿Primera vez? Mirá cómo se usa
    </Link>
  );
}

/** En Tu cuenta: una tarjeta como las demás. */
export function TarjetaUso() {
  return (
    <Link
      to="/uso"
      className="flex items-center gap-3 rounded-3xl border border-stone-200 bg-white p-4 shadow-sm hover:bg-stone-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
    >
      <Icono nombre="help" tamano={28} className="shrink-0 text-primary-700" />
      <span className="min-w-0 flex-1">
        <span className="block text-lg font-bold text-stone-900">Cómo se usa la tienda</span>
        <span className="block text-[15px] text-stone-600">Paso a paso, con las pantallas de verdad.</span>
      </span>
      <Icono nombre="chevron_right" tamano={24} className="shrink-0 text-stone-600" />
    </Link>
  );
}
